<template>
  <div>
    <!-- header start -->
    <van-nav-bar title="我的纪念" fixed class="navbarBg" :border="false">
      <template #right>
        <div class="iconbtn">
          <van-icon name="search" @click="goSearch" />
        </div>
        <div class="iconbtn">
          <van-icon name="add-o" @click="goAddMemorialHall" />
        </div>
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <div class="ad">
      <van-swipe
        class="ad-swipe"
        :height="143"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in adList" :key="index">
          <router-link :to="item.url"><img :src="item.src"/></router-link>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- header end -->
    <van-tabs
      sticky
      animated
      swipeable
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
    >
      <van-tab title="我的创建">
        <my_creat_list ref="myCreatList"></my_creat_list>
      </van-tab>

      <van-tab title="关注">
        <my_follow_list></my_follow_list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import auth from "../tools/auth.js";
import { mapGetters } from "vuex";
import my_creat_list from "@/components/my_creat_list";
import my_follow_list from "@/components/my_follow_list";

export default {
  data() {
    return {
      adList: [
        // {
        //   src: require("@/assets/images/ad.jpg"),
        //   url: "/Zy",
        // },
        // {
        //   src: require("@/assets/images/ad01.jpg"),
        //   url: "/Create",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters(["currentToken", "memberInfo"]),
  },
  components: {
    my_creat_list,
    my_follow_list,
  },
  methods: {
    init() {
      this.getAd();
    },
    getAd(){
      var that = this;
      that.$store
        .dispatch({
          type: "GetCommandAdList",
          id: 31,
        })
        .then((res) => {
          // console.log(res,"zzzzzzzzzz")
          res.forEach((x) => {
            that.adList.push({
              src: x.PhotoPath,
              url: x.MobileLinkUrl
            });
          });
        });
    },
    goSearch() {
      this.$router.push("/Search");
    },
    goAddMemorialHall() {
      this.$router.push("/Create");
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "Login") {
      to.meta.refresh = true;
    } else if (from.name == "CreateSuccess") {
      to.meta.refresh = true;
    } else if (from.name == "Zy") {
      let memberAudio = document.querySelector("#memberAudio");
      memberAudio.pause();
    }
    next();
  },
  activated() {
    console.log("activated");
    //console.log(this.$route.meta.refresh);
    if (this.$route.meta.refresh) {
      if (this.$refs.myCreatList != null) {
        this.$refs.myCreatList.onRefresh();
      }

      this.$route.meta.refresh = false;
    }
  },
  created() {
    var that = this;
    that.$weixin.AutoWeixinAuthorize(that);
    auth.getIsPhoneAuth(that).then((res) => {
      if (!res) {
        that.$router.replace({
          path: "AuthPhoneUser?ReturnUrl=/",
        });
      }
    });
    that.init();
  },
};
</script>

<style lang="less" scoped>
.ad {
  display: flex;
  background-color: #24a378;
  height: 143px;
  .ad-swipe {
    border-radius: 10px;
    margin: 5px 15px;
  }
}
</style>
